import { getMatrixObjectIdentity } from './getMatrixObjectIdentity';
import { LayoutObject } from '../../types/types';

// Data objects of a matrix generation that no button of the layout points at yet
// (the matrixForm `skipExisting` flag).
export const getUnplacedMatrixObjects = (
  dataObjects: LayoutObject[],
  existingObjects: LayoutObject[]
): LayoutObject[] => {
  // 1) Collect the identities the buttons of the layout already occupy.
  const placedIdentities = new Set<string>();

  existingObjects.forEach((object) => {
    const identity = getMatrixObjectIdentity(object);

    if (identity === null) {
      return;
    }

    placedIdentities.add(identity);
  });

  // 2) Nothing occupied → the whole response can be generated.
  if (placedIdentities.size === 0) {
    return dataObjects;
  }

  // 3) Drop the data objects whose identity is already on a button. Data objects
  //    without an identity have nothing to be paired by, so they stay.
  return dataObjects.filter((dataObject) => {
    const identity = getMatrixObjectIdentity(dataObject);

    return identity === null || !placedIdentities.has(identity);
  });
};
